<template>
  <div>
    <!--begin: Navigation -->
    <div class="kt-notification">
      <div class="kt-notification__custom kt-space-between">
        <a
          href="#"
          v-on:click="onLogout()"
          class="btn btn-label btn-label-brand btn-sm btn-bold"
          >Sign Out</a
        >
      </div>
    </div>
    <!--end: Navigation -->
  </div>
</template>

<script>
import { LOGOUT } from "@/store/auth.module";

export default {
  name: "KTDropdownUser",
  methods: {
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    }
  },
  computed: {
    currentUser() {
      let user = this.$store.getters.currentUser;
      user = user.hasOwnProperty("attributes")
        ? user
        : { attributes: { email: "", name: "" } };
      return user.attributes;
    },
    currentUserFirstLetter() {
      if (this.currentUser.name) return this.currentUser.name[0];

      return "";
    }
  }
};
</script>
